import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { Loader } from 'common/components/Loader';

interface IComponentProps {
  title: React.ReactNode;
  variant?: 'overall' | 'notifications' | 'store' | 'sales';
  extra?: React.ReactNode;
  loading?: boolean;
  className?: string;
  children: React.ReactNode;
}

export const DashboardCard: FC<IComponentProps> = ({
  title,
  variant = 'sales',
  extra,
  loading = false,
  children,
  className = '',
}) => {
  return (
    <div className={`flex flex__column dashboard-card dashboard-card--${variant} ${className}`}>
      <div className="pt-3 pb-3 pl-5 pr-5 dashboard-card-header">
        <Row align="middle" className="height-full">
          <Col flex="auto" className="ff-medium fs-xs">
            {title}
          </Col>
          <Col flex="20px">{extra}</Col>
        </Row>
      </div>
      <div className="relative flex__item_1 dashboard-card-content">{loading ? <Loader /> : children}</div>
    </div>
  );
};
